import React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

import type { TestProps } from '../../models';
import { fCurrency } from '../../utils/formatNumber';

interface TestsProps {
	tests: Array<Omit<TestProps, 'price'> & { price?: number }>;
}

/*
 Selected tests review before submission
*/
export const TestReview = ({ tests }: TestsProps) => {
	const hasPrice = tests.some((test) => typeof test.price === 'number');

	return (
		<Table>
			<TableHead
				sx={{
					'& .MuiTableCell-head': {
						bgcolor: 'grey.100',
					},
				}}
			>
				<TableRow>
					<TableCell>Name</TableCell>
					<TableCell>Qty</TableCell>
					{hasPrice && <TableCell>Price</TableCell>}
					{hasPrice && <TableCell>Line Total</TableCell>}
				</TableRow>
			</TableHead>
			<TableBody>
				{tests.map((test) => {
					const unitPrice = test.discountedPrice ?? test.price;

					return (
						<TableRow key={test.id}>
							<TableCell>{test.name}</TableCell>
							<TableCell>{test.quantity}</TableCell>
							{hasPrice && <TableCell>{fCurrency(unitPrice)}</TableCell>}
							{hasPrice && <TableCell>{fCurrency((unitPrice as number) * (test.quantity || 1))}</TableCell>}
						</TableRow>
					);
				})}
			</TableBody>
		</Table>
	);
};
